<template>
    <grid-layout>
        <grid-layout-item>
            <form-item
                :sid="sid"
                :name="`${name}[search]`"
            >
                <template slot="label">Search</template>

                <template slot="help">
                    Search for your address, we'll populate the fields.
                </template>

                <input-address-search
                    :address="address"
                    :disabled="disabled"
                    @input="$emit('input', arguments[0])"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :is-required="isRequired"
                :name="`${name}[street]`"
                :validator-name="`${validatorName}.street`"
            >
                <template slot="label">Line 1</template>

                <input-text
                    v-model="address.street"
                    :sid="sid"
                    :name="`${name}[street]`"
                    :validator-name="`${validatorName}.street`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :name="`${name}[locality]`"
                :validator-name="`${validatorName}.locality`"
            >
                <template slot="label">Line 2</template>

                <input-text
                    v-model="address.locality"
                    :sid="sid"
                    :name="`${name}[locality]`"
                    :validator-name="`${validatorName}.locality`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :name="`${name}[village]`"
                :validator-name="`${validatorName}.village`"
            >
                <template slot="label">Line 3</template>

                <input-text
                    v-model="address.village"
                    :sid="sid"
                    :name="`${name}[village]`"
                    :validator-name="`${validatorName}.village`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :is-required="isRequired"
                :name="`${name}[town]`"
                :validator-name="`${validatorName}.town`"
            >
                <template slot="label">Town</template>

                <input-text
                    v-model="address.town"
                    :sid="sid"
                    :name="`${name}[town]`"
                    :validator-name="`${validatorName}.town`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :name="`${name}[county]`"
                :validator-name="`${validatorName}.county`"
            >
                <template slot="label">County</template>

                <input-text
                    v-model="address.county"
                    :sid="sid"
                    :name="`${name}[county]`"
                    :validator-name="`${validatorName}.county`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>

        <grid-layout-item class="md:w-1/2">
            <form-item
                :sid="sid"
                :name="`${name}[postcode]`"
                :validator-name="`${validatorName}.postcode`"
                :is-required="isRequired"
            >
                <template slot="label">Postcode</template>

                <input-text
                    v-model="address.postcode"
                    :sid="sid"
                    :name="`${name}[postcode]`"
                    :validator-name="`${validatorName}.postcode`"
                    :disabled="disabled"
                />
            </form-item>
        </grid-layout-item>
    </grid-layout>
</template>

<script>
    import InputAddressSearch from './input-address-search'

    export default {
        components: {
            InputAddressSearch
        },
        model: {
            prop: 'address',
            event: 'input'
        },
        props: {
            address: {
                type: Object,
                required: true
            },
            name: {
                type: String,
                default: 'address'
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace(/\[/g, '.').replace(/\]/g, '')
                }
            },
            sid: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isRequired: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
